var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceChannelOrder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.58643 7.99999L7.19309 9.61332L10.4131 6.38666",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16643 1.63332C7.62643 1.23998 8.37976 1.23998 8.84643 1.63332L9.89976 2.53998C10.0998 2.71332 10.4731 2.85332 10.7398 2.85332H11.8731C12.5798 2.85332 13.1598 3.43332 13.1598 4.13998V5.27332C13.1598 5.53332 13.2998 5.91332 13.4731 6.11332L14.3798 7.16665C14.7731 7.62665 14.7731 8.37999 14.3798 8.84665L13.4731 9.89999C13.2998 10.1 13.1598 10.4733 13.1598 10.74V11.8733C13.1598 12.58 12.5798 13.16 11.8731 13.16H10.7398C10.4798 13.16 10.0998 13.3 9.89976 13.4733L8.84643 14.38C8.38643 14.7733 7.63309 14.7733 7.16643 14.38L6.11309 13.4733C5.91309 13.3 5.53976 13.16 5.27309 13.16H4.11976C3.41309 13.16 2.83309 12.58 2.83309 11.8733V10.7333C2.83309 10.4733 2.69309 10.1 2.52643 9.89999L1.62643 8.83999C1.23976 8.37999 1.23976 7.63332 1.62643 7.17332L2.52643 6.11332C2.69309 5.91332 2.83309 5.53998 2.83309 5.27998V4.13332C2.83309 3.42665 3.41309 2.84665 4.11976 2.84665H5.27309C5.53309 2.84665 5.91309 2.70665 6.11309 2.53332L7.16643 1.63332Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceChannelOrder);
export default __webpack_public_path__ + "static/media/placeChannelOrder.c3998708909337a543b4542f287c5ffb.svg";
export { ForwardRef as ReactComponent };